import React, { FC, useState } from 'react'
import {
  createNote,
  DailyNoteModel,
  deleteNote,
  updateNote,
} from '@store/slices/note.slice'
import { Button, Card, FormControl, InputGroup } from 'react-bootstrap'
import { BsPencil, BsX } from 'react-icons/bs'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '@store/store'
import { useForm } from 'react-hook-form'
import { formatDate } from '../../tools/time.tools'

const NoteCard: FC<{
  note: Partial<DailyNoteModel>
  onSaveNew?: () => void
}> = ({ note, onSaveNew }) => {
  const dispatch = useDispatch<AppDispatch>()
  const [isEditMode, setIsEditMode] = useState(note.id === '')
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<DailyNoteModel>()

  const handleSave = (data: DailyNoteModel) => {
    const { title, text, date } = data
    const newNote = {
      date,
      title,
      text,
    }
    if (note.id === '') {
      if (onSaveNew) onSaveNew()
      dispatch(createNote(newNote))
    } else if (note.id) {
      dispatch(updateNote({ id: note.id, data: newNote }))
    }

    setIsEditMode(false)
  }
  const handleReset = () => {
    reset()
  }

  const handleClose = () => {
    if (onSaveNew) onSaveNew()
    setIsEditMode(false)
  }

  const onRemoveNote = (noteToRemove: Partial<DailyNoteModel>) => {
    if (noteToRemove.id) dispatch(deleteNote(noteToRemove.id))
  }

  if (isEditMode) {
    return (
      <Card className="mb-2" style={{ maxWidth: '306px' }}>
        <form onSubmit={handleSubmit(handleSave)}>
          <Card.Header>
            <InputGroup>
              <FormControl
                type="date"
                className="mb-1"
                defaultValue={
                  note.date !== '' ? note.date : formatDate(new Date())
                }
                {...register('date', { required: 'Date is required.' })}
              ></FormControl>
            </InputGroup>
            <FormControl
              type="text"
              defaultValue={note.title !== '' ? note.title : ''}
              placeholder="Doplňte nadpis"
              {...register('title', { required: 'Title is required.' })}
            />
            {errors.title && <p>{errors.title.message}</p>}
          </Card.Header>
          <Card.Body>
            <FormControl
              as="textarea"
              placeholder="Doplňte poznámku"
              defaultValue={note.text !== '' ? note.text : ''}
              style={{ height: '200px' }}
              {...register('text', { required: 'Text is required.' })}
            />
            {errors.text && <p>{errors.text.message}</p>}
          </Card.Body>
          <Card.Footer className="text-right d-flex justify-content-between">
            <Button variant="danger" size="sm" onClick={handleReset}>
              Reset
            </Button>
            <div>
              <Button
                className="me-2"
                variant="secondary"
                onClick={handleClose}
                size="sm"
              >
                Zavřít
              </Button>
              <Button variant="primary" size="sm" type={'submit'}>
                Uložit
              </Button>
            </div>
          </Card.Footer>
        </form>
      </Card>
    )
  } else {
    return (
      <Card className="mb-2" style={{ maxWidth: '306px' }}>
        <Card.Header className="d-flex fw-bold me-1">
          {note.title}
          <Button
            size="sm"
            variant="outline-primary"
            className=" ms-auto me-1"
            style={{ maxHeight: '31px' }}
            onClick={() => setIsEditMode(true)}
          >
            <BsPencil></BsPencil>
          </Button>
          <Button
            size="sm"
            variant="outline-danger"
            style={{ maxHeight: '31px' }}
            onClick={() => onRemoveNote(note)}
          >
            <BsX></BsX>
          </Button>
        </Card.Header>
        <Card.Body>
          <pre
            style={{ whiteSpace: 'pre-wrap', fontFamily: 'Arial, sans-serif' }}
          >
            {note.text}
          </pre>
        </Card.Body>
      </Card>
    )
  }
}

export default NoteCard
